import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle";
import { SidebarContextProvider } from "./store/sidebarContext";
import { LangContextProvider } from "./store/langContext";
import { ThemeContextProvider } from "./store/themeContext";
import { LoginContextProvider } from "./store/loginContext";


const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <LangContextProvider>
    <LoginContextProvider>
      <ThemeContextProvider>
        <SidebarContextProvider>
          <App />
        </SidebarContextProvider>
      </ThemeContextProvider>
    </LoginContextProvider>
  </LangContextProvider>
);
